import React, { useEffect, useState } from 'react';
import { CircularProgress } from '@material-ui/core';
import Select from 'react-select';
import styles from '@/components/IntegrationExport/SizeTable/styles';
import { adminChangeSizeTypeModelAutobook } from '@/actions';

export default ({ setTablesData, tablesData, selectedCompany, pageContent }) => {
  const cls = styles();
  const [selectedType, setSelectedType] = useState(null);
  const [loading, setLoading] = useState(false);
  let tableTypes = [
    { value: 1, label: 'size-type-refer' },
    { value: 2, label: 'size-type/refer' },
    { value: 3, label: 'size/type-refer' },
    { value: 4, label: 'size/type/refer' },
  ];

  const getLabel = (value) => {
    let label = value !== 0 ? value : 1;
    switch (label) {
      case 1:
        return 'size-type-refer';
      case 2:
        return 'size-type/refer';
      case 3:
        return 'size/type-refer';
      case 4:
        return 'size/type/refer';
      default:
        return null;
    }
  };

  useEffect(() => {
    if (tablesData.size_type_model || tablesData.size_type_model === 0) {
      setSelectedType({
        value: tablesData.size_type_model,
        label: getLabel(tablesData.size_type_model),
      });
    }
  }, [tablesData]);

  const handleSelectSizeTypeModel = (sizeTypeModel) => {
    if (sizeTypeModel && selectedCompany) {
      setLoading(true);
      setSelectedType(sizeTypeModel);
      adminChangeSizeTypeModelAutobook(sizeTypeModel.value, selectedCompany.value).then(
        (data) => {
          setLoading(false);
          if (data) {
            setTablesData((prev) => ({
              ...prev,
              ...data,
            }));
          }
        }
      );
    }
  };

  const normalizeToRecordMap = (raw) => {
    if (raw != null && typeof raw === 'object' && !Array.isArray(raw)) return raw;
    return {};
  };

  const handleChangeSizeType = (name, value, key) => {
    let adaptedSizeType = { ...normalizeToRecordMap(tablesData?.size_type) };
    if (key) {
      adaptedSizeType[name] = { ...(adaptedSizeType[name] || {}), [key]: value };
    } else {
      adaptedSizeType[name] = value;
    }
    setTablesData((prev) => ({
      ...prev,
      size_type: adaptedSizeType,
    }));
  };

  const flattenSizeTypeScalar = (value) => {
    if (value == null || value === '') return '';
    if (typeof value !== 'object') return String(value);
    const vals = Object.values(value).filter(
      (v) => v != null && v !== '' && typeof v !== 'object'
    );
    return vals.join(' / ');
  };

  const RenderTable = () => {
    const sizeDefault = normalizeToRecordMap(tablesData?.size_type_default);
    const sizeType = normalizeToRecordMap(tablesData?.size_type);
    switch (selectedType.value) {
      case 1:
        return (
          <table className={cls.list}>
            <thead>
              <tr>
                <th rowspan="2" style={{ flex: 0.7 }}>
                  SMART TURN
                </th>
                <th rowspan="2" style={{ flex: 1 }}>
                  SIZE-TYPE-REFER
                </th>
                <th colspan="1" style={{ flex: 0.7 }}>
                  USER
                </th>
              </tr>
              <tr>
                <th>SIZE-TYPE-REFER</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(sizeDefault).map((key) => (
                <tr>
                  <td style={{ flex: 1 }}>{key}</td>
                  <td style={{ flex: 0.7 }}>
                    {flattenSizeTypeScalar(sizeDefault[key])}
                  </td>
                  <td style={{ flex: 0.7 }}>
                    {pageContent.value === 1 || pageContent.value === 2 ? (
                      <>{flattenSizeTypeScalar(sizeType[key])}</>
                    ) : (
                      <input
                        type="text"
                        value={flattenSizeTypeScalar(sizeType[key])}
                        name={key}
                        onChange={(e) => handleChangeSizeType(e.target.name, e.target.value)}
                      />
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        );
      case 2:
        return (
          <table className={cls.list}>
            <thead>
              <tr>
                <th rowspan="2" style={{ flex: 0.7 }}>
                  SMART TURN
                </th>
                <th rowspan="2" style={{ flex: 1 }}>
                  SIZE-TYPE-REFER
                </th>
                <th colspan="2" style={{ flex: 0.7 }}>
                  USER
                </th>
              </tr>
              <tr>
                <th>SIZE-TYPE</th>
                <th>REFER</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(sizeDefault).map((key) => (
                <tr>
                  <td style={{ flex: 1 }}>{key}</td>
                  <td style={{ flex: 0.7 }}>{sizeDefault[key]}</td>
                  <td style={{ flex: 0.7 }}>
                    {pageContent.value === 1 || pageContent.value === 2 ? (
                      <>{sizeType[key]?.st}</>
                    ) : (
                      <input
                        type="text"
                        value={sizeType[key]?.st || ''}
                        name={key}
                        onChange={(e) => handleChangeSizeType(e.target.name, e.target.value, 'st')}
                      />
                    )}
                  </td>
                  <td style={{ flex: 0.7 }}>
                    {pageContent.value === 1 || pageContent.value === 2 ? (
                      <>{sizeType[key]?.r}</>
                    ) : (
                      <input
                        type="text"
                        value={sizeType[key]?.r || ''}
                        name={key}
                        onChange={(e) => handleChangeSizeType(e.target.name, e.target.value, 'r')}
                      />
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        );
      case 3:
        return (
          <table className={cls.list}>
            <thead>
              <tr>
                <th rowspan="2" style={{ flex: 0.7 }}>
                  SMART TURN
                </th>
                <th rowspan="2" style={{ flex: 1 }}>
                  SIZE-TYPE-REFER
                </th>
                <th colspan="2" style={{ flex: 0.7 }}>
                  USER
                </th>
              </tr>
              <tr>
                <th>SIZE</th>
                <th>TYPE-REFER</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(sizeDefault).map((key) => (
                <tr>
                  <td style={{ flex: 1 }}>{key}</td>
                  <td style={{ flex: 0.7 }}>{sizeDefault[key]}</td>
                  <td style={{ flex: 0.7 }}>
                    {pageContent.value === 1 || pageContent.value === 2 ? (
                      <>{sizeType[key]?.s}</>
                    ) : (
                      <input
                        type="text"
                        value={sizeType[key]?.s || ''}
                        name={key}
                        onChange={(e) => handleChangeSizeType(e.target.name, e.target.value, 's')}
                      />
                    )}
                  </td>
                  <td style={{ flex: 0.7 }}>
                    {pageContent.value === 1 || pageContent.value === 2 ? (
                      <>{sizeType[key]?.tr}</>
                    ) : (
                      <input
                        type="text"
                        value={sizeType[key]?.tr || ''}
                        name={key}
                        onChange={(e) => handleChangeSizeType(e.target.name, e.target.value, 'tr')}
                      />
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        );
      case 4:
        return (
          <table className={cls.list}>
            <thead>
              <tr>
                <th rowspan="3" style={{ flex: 1 }}>
                  SMART TURN
                </th>
                <th rowspan="3" style={{ flex: 1 }}>
                  SIZE-TYPE-REFER
                </th>
                <th colspan="3" style={{ flex: 0.7 }}>
                  USER
                </th>
              </tr>
              <tr>
                <th>SIZE</th>
                <th>TYPE</th>
                <th>REFER</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(sizeDefault).map((key) => (
                <tr>
                  <td style={{ flex: 1 }}>{key}</td>
                  <td style={{ flex: 1 }}>{sizeDefault[key]}</td>
                  <td style={{ flex: 0.7 }}>
                    {pageContent.value === 1 || pageContent.value === 2 ? (
                      <>{sizeType[key]?.s}</>
                    ) : (
                      <input
                        type="text"
                        value={sizeType[key]?.s || ''}
                        name={key}
                        onChange={(e) => handleChangeSizeType(e.target.name, e.target.value, 's')}
                      />
                    )}
                  </td>
                  <td style={{ flex: 0.7 }}>
                    {pageContent.value === 1 || pageContent.value === 2 ? (
                      <>{sizeType[key]?.t}</>
                    ) : (
                      <input
                        type="text"
                        value={sizeType[key]?.t || ''}
                        name={key}
                        onChange={(e) => handleChangeSizeType(e.target.name, e.target.value, 't')}
                      />
                    )}
                  </td>
                  <td style={{ flex: 0.7 }}>
                    {pageContent.value === 1 || pageContent.value === 2 ? (
                      <>{sizeType[key]?.r}</>
                    ) : (
                      <input
                        type="text"
                        value={sizeType[key]?.r || ''}
                        name={key}
                        onChange={(e) => handleChangeSizeType(e.target.name, e.target.value, 'r')}
                      />
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        );
      default:
        return null;
    }
  };

  return (
    <div>
      <div className={cls.header}>
        <h3>SIZE-TYPE-REFER NAMING</h3>
        {pageContent.value !== 1 && pageContent.value !== 2 && (
          <Select
            isClearable
            placeholder="Type"
            className={cls.select}
            defaultValue={selectedType}
            value={selectedType}
            onChange={(item) => {
              handleSelectSizeTypeModel(item);
            }}
            options={tableTypes}
          />
        )}
      </div>
      <div className={cls.listContainer}>
        {selectedType &&
          (loading ? (
            <div className={cls.loaderContainer}>
              <CircularProgress className={cls.loader} />
            </div>
          ) : (
            <>{RenderTable()}</>
          ))}
      </div>
    </div>
  );
};
